import { HelpOutlineOutlined } from '@mui/icons-material';
import { FloatingHelpButtonContainer, HelpButtonText } from './styles';

const helpCenterUrl =
  'https://suporte.celcoin.com.br/hc/pt-br/sections/12011728077211-Plataforma-de-Cr%C3%A9dito';

const FloatingHelpButton = () => {
  const handleClick = () => {
    window.open(helpCenterUrl, '_blank');
  };

  return (
    <FloatingHelpButtonContainer onClick={handleClick}>
      <HelpOutlineOutlined
        sx={{
          color: 'white',
          fontSize: '20px',
        }}
      />
      <HelpButtonText>Suporte</HelpButtonText>
    </FloatingHelpButtonContainer>
  );
};

export default FloatingHelpButton;
